import clsx from "clsx";
import { FC } from "react";
import styled from "styled-components";

import { useTimeEdit } from "@ryde/redux";
import { IRideDto, IRydeRow, TIME_STRING_LENGTH_HHmm } from "@ryde/shared";
import { blueGreyMui, blueMui, greyMui, redMui, rydeColors } from "@ryde/theme";

const TimeEditCellWrapper = styled.div`
  color: ${blueGreyMui._500};
  display: flex;
  align-items: center;
`;

const StyledTimeInput = styled.input`
  font-family: inherit;
  font-size: 14px;
  border-radius: 2px;
  width: 45px;
  text-align: center;
  padding: 3px;
  border: 1px solid ${blueMui._300};
  background-color: ${rydeColors.blueTimeEditBg};
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:focus {
    color: ${rydeColors.greyFocusedInput};
    background-color: ${rydeColors.white};
    border-color: ${blueMui._300};
    outline: 0;
    box-shadow: 0 0 0 0.2rem ${rydeColors.blueTimeEditBg};
  }
  &:disabled,
  &:read-only {
    background-color: ${greyMui.A100};
    opacity: 1;
  }
  &.error {
    background-color: ${redMui.A400};
    border-color: ${redMui.A400};
    color: ${rydeColors.white};
  }
`;

interface ITimeEditCellRides {
  row: IRydeRow<IRideDto>;
}

export const TimeEditCellRides: FC<ITimeEditCellRides> = ({ row }) => {
  const initialValue = row.original.rideStart;
  const { onBlur, hasError, handleTimeInputChange, value } = useTimeEdit(
    initialValue,
    false,
  );

  return (
    <TimeEditCellWrapper>
      <StyledTimeInput
        onChange={handleTimeInputChange}
        onBlur={onBlur}
        className={clsx({ error: hasError })}
        type="text"
        maxLength={TIME_STRING_LENGTH_HHmm}
        value={value}
      />
    </TimeEditCellWrapper>
  );
};
